// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown-module__countdown___2l2je","time":"Countdown-module__time___1_h7_","center":"Countdown-module__center___sVtiU"};